module.exports = __webpack_public_path__ + "static/media/dec2024-1.055715dd.webp";